import sortBy from 'lodash/sortBy';

const mergeWithFakeUploadAttachmentMessages = (messages, attachments) => {
  const attachmentsArray = Object.keys(attachments)
    .filter(key => attachments[key].progress < 100)
    .map(key => attachments[key].message);

  return sortBy(messages.concat(attachmentsArray), 'insertedAt');
};

export default mergeWithFakeUploadAttachmentMessages;



// WEBPACK FOOTER //
// ./src/redux/chatConnection/helpers/mergeWithFakeUploadAttachmentMessages.js